import { fluid } from '@helpers/fluid';
import styled from 'styled-components';
const Field = styled.div `
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-bottom: ${fluid(24, 40)};

  &[data-mobile-number='true'] {
    .PhoneInput {
      display: flex;
      gap: 4px;
    }

    select {
      width: 110px;
    }

    input {
      width: calc(100% - 110px);
    }
  }
`;
export default {
    Field,
};
